var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 503,
    height: 184,
    viewBox: "0 0 503 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.529592,
    y: 33.2967,
    width: 536.74,
    height: 216.894,
    rx: 14.5,
    transform: "rotate(-3.5 0.529592 33.2967)",
    fill: "white",
    stroke: "#9B9B9B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6321,
    y: 103.453,
    width: 133.435,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 64.6321 103.453)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7659,
    y: 138.341,
    width: 187.209,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 66.7659 138.341)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.4983,
    y: 68.5655,
    width: 176.454,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 62.4983 68.5655)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 373.256,
    y: 84.5772,
    width: 66.2175,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 373.256 84.5772)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 375.389,
    y: 119.465,
    width: 66.2175,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 375.389 119.465)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 371.122,
    y: 49.6892,
    width: 66.2175,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 371.122 49.6892)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 292.745,
    y: 89.5013,
    width: 66.2175,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 292.745 89.5013)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 294.879,
    y: 124.389,
    width: 66.2175,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 294.879 124.389)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 290.611,
    y: 54.6136,
    width: 66.2175,
    height: 20.5096,
    rx: 10.2548,
    transform: "rotate(-3.5 290.611 54.6136)",
    fill: "#DBDBDD",
    stroke: "#9B9B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463.694 44.6419C463.995 43.8039 465.082 43.7375 465.483 44.5325L465.93 44.3074L465.483 44.5325L467.77 49.0667C468.094 49.7084 468.725 50.1366 469.44 50.1733L474.334 50.4247C475.158 50.4671 475.621 51.5508 474.995 52.2196L471.581 55.8679C471.093 56.39 470.913 57.1368 471.097 57.8304L472.405 62.765C472.65 63.6923 471.746 64.3588 471.03 63.9875L466.634 61.7081C465.997 61.3777 465.238 61.4241 464.646 61.8297L460.56 64.6279C459.894 65.0837 458.916 64.5323 459.047 63.582L459.743 58.5249C459.841 57.814 459.572 57.0946 459.023 56.636L455.19 53.4309C454.488 52.8434 454.815 51.7113 455.628 51.5689L460.455 50.7229C461.159 50.5994 461.734 50.0973 461.977 49.4211L463.694 44.6419Z",
    fill: "white",
    stroke: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.829 79.5296C466.13 78.6916 467.217 78.6251 467.618 79.4202L468.065 79.1951L467.618 79.4202L469.905 83.9544C470.228 84.5961 470.86 85.0243 471.575 85.061L476.469 85.3124C477.293 85.3548 477.756 86.4385 477.13 87.1073L473.716 90.7556C473.228 91.2777 473.048 92.0245 473.232 92.7181L474.539 97.6526C474.785 98.58 473.881 99.2465 473.165 98.8752L468.769 96.5958C468.131 96.2654 467.373 96.3118 466.78 96.7173L462.694 99.5156C462.029 99.9714 461.051 99.42 461.181 98.4696L461.878 93.4126C461.976 92.7016 461.706 91.9823 461.158 91.5237L457.325 88.3186C456.622 87.7311 456.95 86.599 457.762 86.4566L462.59 85.6106C463.294 85.4871 463.869 84.985 464.112 84.3087L465.829 79.5296Z",
    fill: "white",
    stroke: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M467.963 114.418C468.264 113.58 469.351 113.513 469.752 114.308L470.198 114.083L469.752 114.308L472.039 118.843C472.362 119.484 472.994 119.912 473.708 119.949L478.603 120.201C479.426 120.243 479.89 121.327 479.264 121.995L475.85 125.644C475.361 126.166 475.182 126.913 475.365 127.606L476.673 132.541C476.919 133.468 476.015 134.135 475.299 133.763L470.902 131.484C470.265 131.154 469.506 131.2 468.914 131.606L464.828 134.404C464.163 134.86 463.184 134.308 463.315 133.358L464.012 128.301C464.11 127.59 463.84 126.871 463.292 126.412L459.459 123.207C458.756 122.619 459.084 121.487 459.896 121.345L464.723 120.499C465.428 120.375 466.003 119.873 466.246 119.197L467.963 114.418Z",
    fill: "white",
    stroke: "#9B9B9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.b5a17a12.svg";
export { ForwardRef as ReactComponent };